import { render, staticRenderFns } from "./NreBarcode.vue?vue&type=template&id=54953afa&scoped=true&"
import script from "./NreBarcode.vue?vue&type=script&lang=js&"
export * from "./NreBarcode.vue?vue&type=script&lang=js&"
import style0 from "./NreBarcode.vue?vue&type=style&index=0&id=54953afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54953afa",
  null
  
)

export default component.exports